import Box from "@mui/material/Box";
import styled from "styled-components";

export const ModalContent = styled(Box)`
  && {
    max-width: 1024px;
    max-height: 100vh;
    overflow-y: auto;

    margin: auto;
    padding: 24px;
    outline: none;

    &::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for Firefox */
    scrollbar-width: none;

    /* Hide scrollbar for IE and Edge */
    -ms-overflow-style: none; 
  }
`;

export const CloseButtonContainer = styled(Box)`
  && {
    margin-bottom: 16px;
  }
`;